import firebase from "firebase";

export const firebase_connect = firebase.initializeApp({
    apiKey: "AIzaSyBZ-ytC2lYTtDd13cBoPMF8PIpGU7kGiN8",
    authDomain: "magnum-1542302911525.firebaseapp.com",
    databaseURL: "https://magnum-1542302911525.firebaseio.com",
    projectId: "magnum-1542302911525",
    storageBucket: "magnum-1542302911525.appspot.com",
    messagingSenderId: "853307678406"
});








// WEBPACK FOOTER //
// ./src/Frontend/config/firebase/api.js